/**
 * Settings Line-2 peers (same SubPageNav style as buildings).
 * Overview · Checklist templates · Mail · DB Setting
 */

export function getSettingsPeerNav(pathname) {
  const peers = [
    { id: 'overview', label: 'Overview', to: '/settings' },
    { id: 'inspection', label: 'Inspection module', to: '/settings/inspection' },
    { id: 'checklists', label: 'Checklist templates', to: '/settings/checklists' },
    { id: 'mail', label: 'Mail', to: '/settings/mail' },
    { id: 'db', label: 'DB Setting', to: '/settings/db' },
  ];
  const activeId = detectSettingsPeer(pathname);
  return peers.map((p) => ({ label: p.label, to: p.to, active: p.id === activeId }));
}

function detectSettingsPeer(pathname) {
  const p = pathname || '';
  if (p.startsWith('/settings/inspection')) return 'inspection';
  if (p.startsWith('/settings/checklists')) return 'checklists';
  if (p.startsWith('/settings/mail')) return 'mail';
  if (p.startsWith('/settings/db')) return 'db';
  if (p === '/settings') return 'overview';
  return 'overview';
}

export function resolveSettingsNav({ pathname }) {
  const p = pathname || '';
  if (p === '/settings') {
    return { trail: [], subPages: getSettingsPeerNav(p) };
  }
  if (p.startsWith('/settings/db/structure')) {
    return {
      trail: [
        { label: 'Settings', to: '/settings' },
        { label: 'DB Setting', to: '/settings/db' },
      ],
      subPages: getSettingsPeerNav(p),
    };
  }
  return {
    trail: [{ label: 'Settings', to: '/settings' }],
    subPages: getSettingsPeerNav(p),
  };
}
